import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"
import SortDropdown from "./elements/SortDropdown"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-text-align-center ns-align-items-center ${className} ns-font-4`}
        >
            <span class="icon icon-new icon-filter ">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.302 16.751h3.394m16 0H11.583" stroke="currentColor" stroke-width="1.358" stroke-miterlimit="6.667" stroke-linecap="square" stroke-linejoin="round"></path>
                        <path d="M8.606 19.66a2.91 2.91 0 1 0 0-5.818 2.91 2.91 0 0 0 0 5.818z" stroke="currentColor" stroke-width="1.358" stroke-miterlimit="10" stroke-linecap="round"></path>
                        <path d="M2.302 8.024h10.182m9.212 0h-3.394" stroke="currentColor" stroke-width="1.358" stroke-miterlimit="6.667" stroke-linecap="square" stroke-linejoin="round"></path>
                        <path d="M15.393 10.933a2.91 2.91 0 1 0 0-5.818 2.91 2.91 0 0 0 0 5.818z" stroke="currentColor" stroke-width="1.358" stroke-miterlimit="10" stroke-linecap="round"></path>
                </svg>
            </span>
            <span>Filter</span>
            {selectedFiltersCount > 0 && (
                // ns-d-inline-block
                <span className="ns-total-count ns-text-align-center">
                    {selectedFiltersCount}
                </span>
            )}
            <span class="icon icon-new icon-chevron-small ">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.875 7.438 12 17.563 22.125 7.438" stroke="currentColor" stroke-width="2.75"></path></svg>
            </span>
        </label>
    )
}

export default function Toolbar({isChecked}) {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0
    // pageType === "category" ? `${docCount} results` : `'${query.query}' -
    const totalSummary =  `${docCount} results`;

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <div
            class={`ns-header-controls ns-d-flex ns-d-none ns-d-md-flex align-center ns-justify-content-between ${isChecked ? "ns-sidebar-checked" : ""}`}
            // style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
            <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-w-100">
                {!loading && (
                    <span
                        class="ns-d-inline ns-text-align-center ns-d-md-block ns-align-self-md-center ns-total-results-count"
                        data-nosto-element="totalResults"
                    >
                        {totalSummary}
                    </span>
                )}
                <SortDropdown />
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                    label={"Sort by"}
                /> */}
            </div>
        </div>
    )
}
